var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 30,
    viewBox: "0 0 8 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_812_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.89985C0 9.35845 0.257813 8.97817 0.773438 8.75903C1.28906 8.53989 1.74023 8.62368 2.12695 9.0104L7.07695 13.9604C7.30899 14.2182 7.425 14.5147 7.425 14.8499C7.425 15.185 7.30899 15.4815 7.07695 15.7393L2.12695 20.6893C1.74023 21.076 1.28906 21.1598 0.773438 20.9407C0.257813 20.7215 0 20.3413 0 19.7999V9.89985ZM6.1875 14.8499L1.2375 9.89985V19.7999L6.1875 14.8499Z",
    fill: "#838694"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_812_1118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.425,
    height: 29.7,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 29.7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlan);
export default __webpack_public_path__ + "static/media/iconPlan.edeab602233eef04a8c3d706100af826.svg";
export { ForwardRef as ReactComponent };